import ProviderCampaignView from './components/ProviderCampaignView';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import has from 'lodash/has';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
  loadCampaign,
  loadBrand
} from '../../shared/redux/entities/actions'

import {
  loadAccountHistory
} from '../../shared/redux/accounting/actions';


function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId;

  return {
    campaignId:campaignId,
    needsLoading:!has(state,['entities','campaigns',campaignId,'id']),
    name:get(state,['entities','campaigns',campaignId,'name'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ 
    loadCampaign,
    loadBrand,
    loadAccountHistory 
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ProviderCampaignView));



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignView/index.js